/**
 * Created by Administrador on 24/04/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('taxLegendService',taxLegendService);

    taxLegendService.$inject = ['$http', 'CONFIG','messageService'];

    function taxLegendService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FINANCE + '/' + CONFIG.API + '/taxLegends';

        var service = {
            getTaxLegends: getTaxLegends,
            getPageTaxLegends: getPageTaxLegends,
            getTaxLegend: getTaxLegend,
            saveTaxLegend: saveTaxLegend,
            updateTaxLegend: updateTaxLegend,
            deleteTaxLegend: deleteTaxLegend
        };

        return service;

        function getTaxLegends(){
            return $http.get(urlBase)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.taxLegends : [];
                }, function(){
                    messageService.findAllError('');
                });
        }

        function getPageTaxLegends(page, size){
            return $http.get(urlBase + "/" + 'page?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getTaxLegend(id){
            return $http.get(urlBase + "/" + id)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findAllError('');
                });
        }

        function saveTaxLegend(taxLegend){
            return $http.post(urlBase, taxLegend)
                .then(function(){
                    messageService.register('taxLegends');
                }, function(){
                    messageService.registerError('');
                });
        }

        function updateTaxLegend(taxLegend, id){
            return $http.put(urlBase + "/" + id, taxLegend)
                .then(function(){
                    messageService.registerUpdate('taxLegends');
                }, function(){
                    messageService.registerUpdateError('');
                });
        }

        function deleteTaxLegend(id){
            return $http.delete(urlBase + "/" + id)
                .then(function(){
                    messageService.registerDelete('taxLegends');
                }, function(error){
                    if(error.data.message.indexOf('asociación')> -1 || error.data.message.indexOf('asociacion') > -1
                        || error.data.message.indexOf('association') > -1 || error.data.message.indexOf('associated') > -1){
                        messageService.registerDeleteGeneralError('taxLegends','air.taxLegend.associatedInvoices');
                    }else{
                        messageService.registerDeleteError('taxLegends');
                    }
                })
        }
    }
})();
